import { useQuery } from '@tanstack/react-query';
import { clientGetEstateStatusFirmTemplate, useGraphqlClient } from '../../graphql';
import { estateStatusKeys } from '../queryKeys';

export function useEstateStatusFirmTemplate(firmID: string | undefined | null) {
  const gqlClient = useGraphqlClient();

  const query = useQuery({
    enabled: !!firmID,
    queryKey: estateStatusKeys.firmTemplate(firmID),
    queryFn: () => {
      if (!firmID) throw new Error('Firm ID is required to load Estate Status firm template.');

      return clientGetEstateStatusFirmTemplate(gqlClient, { firmID });
    },
  });

  return { estateStatusFirmTemplate: query.data, estateStatusFirmTemplateQuery: query };
}
